import React from "react";

export function Footer() {
  return <footer style={{marginTop:'1.5rem'}}class="ftr has-text-centered has-background-grey-dark has-text-light has-text-centered">

  <p>
    Made with ❤.
  </p>


  </footer>
}
export default Footer
